import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from '@Redux/type';
import { AppState } from '@Redux/store';
import bt_tool_pairing from '@Images/en/bt_tool-pairing.png';
import bt_new_army_list from '@Images/en/bt_new_army_list.png';
import add_army_folder from '@Images/en/add_army_folder.png';
import all_versions from '@Images/en/all_versions.png';
import bt_search_army_list from '@Images/en/bt_search_army_list.png';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import myBuilderSlice from '@Redux/reducers/builder/myBuilder.slice';
import { MyBuilderActionState } from '@Stores/builder/MyBuilderState';

const BoardActionComponent: React.FC<BoardActionComponentProps> = ({
                                                                     createArmyList,
                                                                     formatArmyList,
                                                                     createFolder
                                                                   }) => {
  return (
    <section className="mt-2">
      <Row className="justify-content-center">
        <Col xs={6} md={3} xl={2} className="army_list_row">
          <a href="#" onClick={(e) => createArmyList(e)}>
            <img src={`${process.env.CDN ?? ''}${bt_new_army_list}`} className="img-fluid w-100" alt="" />
            <h4 className="boxtitre"><FormattedMessage {...defaultMessages.armyListIndexAdd} /></h4>
          </a>
        </Col>

        <Col xs={6} md={3} xl={2} className="army_list_row">
          <a href="#" onClick={(e) => formatArmyList(e)}>
            <img src={`${process.env.CDN ?? ''}${bt_search_army_list}`} className="img-fluid w-100" alt="" />
            <h4 className="boxtitre"><FormattedMessage {...defaultMessages.armyListFormatTitle} /></h4>
          </a>
        </Col>

        <Col xs={6} md={3} xl={2} className="army_list_row">
          <a href="#" onClick={(e) => createFolder(e)}>
            <img src={`${process.env.CDN ?? ''}${add_army_folder}`} className="img-fluid w-100" alt="" />
            <h4 className="boxtitre"><FormattedMessage {...defaultMessages.armyListIndexFolder} /></h4>
          </a>
        </Col>

        <Col xs={6} md={3} xl={2} className="army_list_row">
          <a href={`/${document.documentElement.lang}/ninth_age/lexicons`}>
            <img src={`${process.env.CDN ?? ''}${all_versions}`} className="img-fluid w-100" alt="" />
            <h4 className="boxtitre"><FormattedMessage {...defaultMessages.lexiconIndexShow} /></h4>
          </a>
        </Col>

        <Col xs={6} md={3} xl={2} className="army_list_row">
          <Link to={`/${document.documentElement.lang}/tool/pairing/drafts/new`}>
            <img src={`${process.env.CDN ?? ''}${bt_tool_pairing}`} className="img-fluid w-100" alt="" />
            <h4 className="boxtitre"><FormattedMessage  {...defaultMessages.homeWhoareweDraft} /></h4>
          </Link>
        </Col>

        <Col xs={6} md={3} xl={2} className="army_list_row">
          <a href={`/${document.documentElement.lang}/builder/searchs`}>
            <img src={`${process.env.CDN ?? ''}${bt_search_army_list}`} className="img-fluid w-100" alt="" />
            <h4 className="boxtitre"><FormattedMessage {...defaultMessages.searchListIndexSearchList} /></h4>
          </a>
        </Col>
      </Row>
    </section>
  );
};

const mapStateToProps = (_: AppState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  createArmyList: (e: any) => {
    e.preventDefault();
    dispatch(myBuilderSlice.actions.setRequest(MyBuilderActionState.ArmyListCreation));
  },
  formatArmyList: (e: any) => {
    e.preventDefault();
    dispatch(myBuilderSlice.actions.setRequest(MyBuilderActionState.ArmyListFormat));
  },
  createFolder: (e: any) => {
    e.preventDefault();
    dispatch(myBuilderSlice.actions.setRequest(MyBuilderActionState.FolderCreation));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(BoardActionComponent);

type BoardActionComponentProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>